import type { NavQueryKey } from './url-params';

/**
 * Navigator-page 로 향하는 path 의 query 조립 SSOT — `NAV_QUERY_KEYS` 위에서 동작.
 *
 * 여러 write 측이 공유해 URL 조립 메커니즘을 한 곳에서 담당:
 *   - navigator 의 `goToLogin` / `goToUnauthorized` (트리 안 imperative)
 *   - 라우트 loader 의 declarative `redirect()` (예: 구독 진입 게이트)
 *
 * 도메인 무지(domain-agnostic) — 어떤 키를 쓸지는 *호출처*가 정한다. `reason` 은
 * `/error/unauthorized` 호출처에서만 등장하고, 헬퍼는 `UnauthorizedReason` 을 알지
 * 않는다. 키는 `NavQueryKey` 로 제약돼 오타가 막힌다. 값의 안전성 검증은 본 함수 밖
 * 책임 — 읽기 측 `query-schemas.ts` 의 zod 가 페이지 진입 전 normalize 한다.
 * URLSearchParams 가 encode 를 자동 처리하므로 수동 encodeURIComponent 불필요.
 * falsy(빈 문자열·null·undefined) 값은 누락 처리.
 */
export function buildNavPath(
  basePath: string,
  query: Partial<Record<NavQueryKey, string | null | undefined>> = {},
): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value) params.set(key, value);
  }
  const qs = params.toString();
  return qs ? `${basePath}?${qs}` : basePath;
}
